module.exports = __webpack_public_path__ + "static/media/close_acrdin_ic.93443caa.svg";